
import { Component, Vue } from "vue-property-decorator";
import { etablissementService } from "@/core/service/licencesnationales/EtablissementService";
import { editeurService } from "@/core/service/licencesnationales/EditeurService";
import { iPService } from "@/core/service/licencesnationales/IPService";
import { rulesForm } from "@/core/RulesForm";

@Component
export default class Recherche extends Vue {
  criteres: string = "";
  domaine: string = "";
  domaineValide: string = "";
  listeDomaine: Array<string> = ["Etablissements", "IPs", "Editeurs"];
  resultats: Array<string> = [];
  message: string = "";
  afficheResultat: boolean = false;
  buttonLoading: boolean = false;
  rulesForm: any = rulesForm;

  search() {
    if (
      (this.$refs.searchForm as Vue & {
        validate: () => boolean;
      }).validate()
    ) {
      const listeCriteres: Array<string> = this.criteres.split(" ");
      this.domaineValide = this.domaine;
      let service;
      switch (this.domaineValide) {
        case "Etablissements":
          service = etablissementService;
          break;
        case "IPs":
          service = iPService;
          break;
        case "Editeurs":
          service = editeurService;
          break;
        default:
          this.message = "Le domaine de recherche est obligatoire";
          return;
      }

      this.buttonLoading = true;
      this.resultats = [];
      service
        .search(listeCriteres, this.$store.getters.getToken())
        .then(res => {
          this.afficheResultat = true;
          res.data.forEach(element => {
            this.resultats.push(element);
          });
        })
        .catch(err => {
          this.message = err.data.message;
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    }
  }

  clickEtab(item): void {
    this.$store
      .dispatch("setCurrentEtablissement", item)
      .then(() => {
        this.$router.push({ name: "AfficherEtablissement" });
      })
      .catch(err => {
        this.message = err.data.message;
        // On glisse sur le message d'erreur
        window.scrollTo(0, 0);
      });
  }

  clickIP(item): void {
    this.$store
      .dispatch("setCurrentEtablissement", item)
      .then(() => {
        this.$router.push({ name: "ListeIP" });
      })
      .catch(err => {
        this.message = err.data.message;
        // On glisse sur le message d'erreur
        window.scrollTo(0, 0);
      });
  }

  clickEditeur(item): void {
    this.$store
      .dispatch("setCurrentEditeur", item)
      .then(() => {
        this.$router.push({ name: "ModifierEditeur" });
      })
      .catch(err => {
        this.message = err.data.message;
        // On glisse sur le message d'erreur
        window.scrollTo(0, 0);
      });
  }
}
